<template>
    <v-container fluid>
        <v-card flat class="mr-3" :loading="loading">
            <v-card-title>{{ pageTitle }}</v-card-title>
            <v-card-subtitle>{{ pageSubtitle }}</v-card-subtitle>
            <v-card-text v-if="ambassador != null">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="6">
                            <div class="subheading grey--text">
                                General Information
                            </div>

                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-text-field v-model="ambassador.name" label="Name" :rules="[ rules.required ]"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="ambassador.school" label="School" :rules="[ rules.required ]"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch v-model="ambassador.active" label="Active"></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>

                <div class="text-right mt-7">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div class="caption">
                            Created at: {{ formatDate( ambassador.dateCreated, 'MMM DD, YYYY' ) }}
                        </div>
                        <div>
                            <v-btn depressed color="grey darken-4" class="white--text" @click="save" :loading="saving">Save</v-btn>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { API } from '@/inc/api';
import { _st } from '@/softech';
import moment from 'moment';

export default {
    props: {
        ambassadorId: { type: [ Number, String ], default: null }
    },
    data: () => ({
        ambassador          : null,
        loading             : false,
        saving              : false,

        rules               : {
            required        : v => !!v || 'required',
        },
    }),
    computed: {
        pageTitle() {
            if( _st.isNUE( this.ambassadorId ) || this.ambassadorId == 'new' ) {
                return 'Create new ambassador';
            }
            
            return 'Edit ambassador';
        },
        pageSubtitle() {
            if( _st.isNUE( this.ambassadorId ) ) {
                return 'Create a new ambassador to be used within the LFA Rental App';
            }
            else {
                return 'Edit all the details of the ambassador';
            }
        },
        isEdit() {
            return !_st.isNUE( this.ambassadorId ) && this.ambassadorId !== 'new';
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions({
            saveAmbassador: 'ambassadors/saveAmbassador'
        }),
        async init() {
            try {
                this.cleanAmbassadorObject();

                if( _st.isNUE( this.ambassadorId ) || this.ambassadorId == 'new' ) {
                    return;
                }

                let api = new API();

                this.loading = true;
                let res = await api.get(`/admin/ambassador/${this.ambassadorId}`);

                if( !res.data.status ) {
                    this.mxShowMessage( res.data.message, res.data.error ? 'error' : 'warning' );
                    return false;
                }

                if( _st.isNUE( res.data.data.id ) )
                    this.$router.push('/404');

                this.ambassador = res.data.data;
            }
            catch(error) {
                this.loading = false;
                this.mxShowMessage( error, 'error' );
            }
            finally {
                this.loading = false;
            }
        },
        cleanAmbassadorObject() {
            this.ambassador = {
                id              : 0,
                name            : '',
                school          : '',
                active          : false,
                dateCreated     : null,
            };
        },
        async save() {
            if( !this.$refs.form.validate() )
                return;

            try {
                this.saving = true;
                let res = await this.saveAmbassador( this.ambassador );

                if( res.status === false ) {
                    this.mxShowMessage( res.message, res.error ? 'error' : 'warning' );
                    return;
                }

                if( this.isEdit ) {
                    this.ambassador = res.data;
                }
                else {
                    this.$router.push(`/ambassadors/${res.data.id}`);
                }

                this.mxShowMessage( 'Ambassador saved', 'success' );
            }
            catch(error) {
                this.saving = false;
                this.mxShowMessage( 'ERROR: ' + error, 'error' );
            }
            finally {
                this.saving = false;
            }
        },
        formatDate(d, f = 'YYYY-MM-DD') {
            if( _st.isNUE( d ) )
                return '';

            return moment(d).format(f);
        },
    }
}
</script>

<style lang="scss" scoped>

</style>